<template>
  <el-table
    :data="collections"
    class="editorial-table"
    border
    fit
    highlight-current-row
    row-key="id"
  >
    <el-table-column
      type="index"
      width="35"
    />

    <el-table-column
      width="210"
      align="center"
      label="Type"
    >
      <template slot-scope="{ row, $index }">
        <el-select
          :disabled="row.type.disabled"
          :value="row.collection_type_id"
          placeholder="Select"
          @change="handleCollectionTypeChange($event, row, $index)"
        >
          <el-option
            v-for="type in collectionTypes"
            :key="type.value"
            :label="type.label"
            :value="type.value"
            :disabled="type.disabled"
          />
        </el-select>
      </template>
    </el-table-column>

    <el-table-column
      min-width="250"
      align="center"
    >
      <template slot-scope="{ row, $index }">
        <home-collections-input-item
          :collection="row"
          @update="handleCollectionInputUpdated($event, $index)"
        />
      </template>
    </el-table-column>

    <el-table-column
      :label="$t('table.action')"
      align="center"
      width="60"
    >
      <template slot-scope="{ row, $index }">
        <el-button
          :disabled="!canDelete(row)"
          size="mini"
          type="danger"
          icon="el-icon-delete"
          circle
          @click="handleCollectionDeleted(row, $index)"
        />
      </template>
    </el-table-column>

    <el-table-column
      align="center"
      label="Drag"
      width="55"
    >
      <span class="drag-handler">
        <font-awesome-icon
          class="drag"
          icon="arrows-alt"/>
      </span>
    </el-table-column>

  </el-table>
</template>

<script>
import Sortable from 'sortablejs'
import HomeCollectionsInputItem from './HomeCollectionsInputItem.vue'

export default {
  name: 'HomeCollectionsTable',
  components: {
    HomeCollectionsInputItem,
  },
  props: {
    collections: {
      type: Array,
      required: true,
    },
    collectionTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sortableObject: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setSort()
    })
  },
  methods: {
    canDelete(collection) {
      return collection.new || !collection.type.disabled
    },
    handleCollectionTypeChange(newValue, collection, index) {
      const deepCopy = JSON.parse(JSON.stringify(collection))
      deepCopy.collection_type_id = newValue
      deepCopy.type = this.collectionTypes.find(type => type.value === newValue)
      deepCopy.banner_ids = ''
      deepCopy.title = ''
      deepCopy.title_zh_hk = ''
      deepCopy.title_zh_cn = ''
      deepCopy.title_th_th = ''
      deepCopy.image = ''

      this.$emit('updateCollection', {
        updatedCollection: deepCopy,
        itemIndex: index,
      })
    },
    handleCollectionInputUpdated(updatedCollection, index) {
      this.$emit('updateCollection', {
        updatedCollection,
        itemIndex: index,
      })
    },
    handleCollectionDeleted(collection, index) {
      this.$emit('deleteCollection', index)
    },
    setSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortableObject = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        handle: '.drag-handler',
        setData(dataTransfer) {
          dataTransfer.setData('Text', '')
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
        },
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt
          this.$emit('updateOrder', { oldIndex, newIndex })
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/table.scss";
</style>
